import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isOptionalString, isPlainObject, isStringArray} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import type {EntityCardProps} from './entity-card.types';
import {EntityCardEntityType} from './entity-card.types';
import {EntityCard} from './entity-card';

const parseEntityType = (value: unknown): EntityCardEntityType | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }

  const knownTypes: string[] = Object.values(EntityCardEntityType);
  if (!knownTypes.includes(value)) {
    return undefined;
  }

  return value as EntityCardEntityType;
};

export const entityCardRegistration = defineStreamComponentRegistration(
  StreamComponentType.ENTITY_CARD,
  EntityCard,
  (props: Record<string, unknown>): EntityCardProps | null => {
    if (!isStringArray(props.meta) || !isOptionalString(props.title) || !isOptionalString(props.mediaUrl) || !isOptionalString(props.icon)) {
      return null;
    }

    return {
      title: props.title,
      meta: props.meta,
      mediaUrl: props.mediaUrl,
      icon: props.icon,
      entityType: parseEntityType(props.entityType),
      entity: isPlainObject(props.entity) ? props.entity : undefined,
    };
  }
);
